<!-- ========== PAGE HERO ========== -->
<section class="ds-page-hero">
  <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
  <div class="container ds-page-hero__inner">
    <span class="ds-pill">Çerezler</span>
    <h1>Çerez Bilgilendirme Metni</h1>
    <p class="ds-lead">
      keyo-ai.com üzerinde hangi çerez ve benzeri teknolojilerin kullanıldığını
      ve bunları nasıl yönetebileceğinizi açıklıyoruz.
    </p>
  </div>
</section>

<!-- ds-legal => scroll-reveal gözlemcisinden muaftır (app.component.ts) -->
<section class="ds-section ds-legal">
  <div class="container">
    <div class="ds-legal__doc">

      <p class="ds-legal__meta">
        Son güncelleme:
        <time [attr.datetime]="lastUpdated.iso">{{ lastUpdated.label }}</time>
      </p>

      <nav class="ds-legal__toc" aria-label="İçindekiler">
        <h2>İçindekiler</h2>
        <ol>
          <li><a href="#amac">Amaç ve Kapsam</a></li>
          <li><a href="#cerez-nedir">Çerez Nedir?</a></li>
          <li><a href="#turler">Çerez Türleri</a></li>
          <li><a href="#kullandiklarimiz">Sitemizde Kullanılan Teknolojiler</a></li>
          <li><a href="#ucuncu-taraf">Üçüncü Taraf Bağlantıları</a></li>
          <li><a href="#yonetim">Çerezleri Yönetme</a></li>
          <li><a href="#sure">Saklama Süreleri</a></li>
          <li><a href="#aktarim">Elde Edilen Verilerin Aktarımı</a></li>
          <li><a href="#haklariniz">Haklarınız</a></li>
          <li><a href="#iletisim">İletişim</a></li>
        </ol>
      </nav>

      <h2 id="amac">1. Amaç ve Kapsam</h2>
      <p>
        İşbu Çerez Bilgilendirme Metni, <strong>Keyo Dijital Çözümler A.Ş.</strong>
        (<strong>"Şirket"</strong> veya <strong>"Keyo AI"</strong>) tarafından
        işletilen <a href="https://keyo-ai.com">keyo-ai.com</a> internet sitesinde
        (<strong>"Site"</strong>) kullanılan çerezler ve benzeri teknolojiler
        hakkında bilgi vermek amacıyla hazırlanmıştır.
      </p>
      <p>
        Metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu
        (<strong>"KVKK"</strong>) ve ilgili mevzuat çerçevesinde oluşturulmuştur
        ve <a routerLink="/aydinlatma-metni">Aydınlatma Metni</a> ile birlikte
        değerlendirilmelidir.
      </p>

      <h2 id="cerez-nedir">2. Çerez Nedir?</h2>
      <p>
        Çerezler (cookies), bir internet sitesini ziyaret ettiğinizde tarayıcınız
        aracılığıyla cihazınıza yerleştirilen küçük metin dosyalarıdır. Çerezler
        sayesinde site, tercihlerinizi ve oturum bilgilerinizi hatırlayabilir.
        Benzer amaçlarla yerel depolama (local storage), oturum depolaması
        (session storage) ve piksel etiketleri gibi teknolojiler de kullanılabilir.
      </p>

      <h2 id="turler">3. Çerez Türleri</h2>
      <p>
        Çerezler genel olarak aşağıdaki kategorilere ayrılır. Sitemizde bu
        kategorilerden hangilerinin fiilen kullanıldığı bir sonraki bölümde
        açıklanmıştır.
      </p>
      <h3>a) Zorunlu Çerezler</h3>
      <p>
        Sitenin çalışması için kesinlikle gereklidir; talep ettiğiniz hizmetlerin
        sunulabilmesi, oturumun yönetilmesi ve güvenliğin sağlanması amacıyla
        kullanılır. Açık rıza gerektirmez.
      </p>
      <h3>b) İşlevsellik Çerezleri</h3>
      <p>
        Dil tercihi, bölge ayarı gibi önceki tercihlerinizin hatırlanmasını
        sağlar.
      </p>
      <h3>c) Performans ve Analitik Çerezleri</h3>
      <p>
        Site trafiğini analiz eder, ziyaretçi davranışlarına ilişkin istatistik
        üretir. Açık rıza gerektirir.
      </p>
      <h3>d) Reklam ve Pazarlama Çerezleri</h3>
      <p>
        Profil oluşturma, yeniden pazarlama ve ilgi alanına dayalı reklam
        gösterimi amacıyla kullanılır. Açık rıza gerektirir.
      </p>

      <h2 id="kullandiklarimiz">4. Sitemizde Kullanılan Teknolojiler</h2>
      <p>
        Sitemiz, <strong>analitik veya reklam/pazarlama amaçlı çerez
        kullanmamaktadır.</strong> Google Analytics, Meta Pixel ve benzeri
        izleme araçları Sitede yer almamaktadır. Sitemiz kendi alan adı üzerinde
        pazarlama amaçlı çerez yerleştirmemektedir.
      </p>
      <p>
        Sitede kullanılan teknolojiler ve bunların yol açtığı veri işleme
        faaliyetleri aşağıdaki tabloda özetlenmiştir:
      </p>
      <div class="ds-legal__table-wrap">
        <table class="ds-legal__table">
          <caption>Sitede kullanılan çerez ve benzeri teknolojiler.</caption>
          <thead>
            <tr>
              <th scope="col">Teknoloji</th>
              <th scope="col">Kategori</th>
              <th scope="col">Amaç ve İşlenen Veri</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Teknoloji">Keyo AI asistan widget'ı</td>
              <td data-label="Kategori">Zorunlu / işlevsellik</td>
              <td data-label="Amaç ve İşlenen Veri">Sitedeki sohbet asistanının çalışması ve görüşme oturumunun sürdürülmesi. Widget üçüncü taraf bir alan adı üzerinden yüklenir ve kendi oturum verilerini kullanabilir; bu kapsamda IP adresiniz ilgili sunucuya iletilir.</td>
            </tr>
            <tr>
              <td data-label="Teknoloji">Google Fonts</td>
              <td data-label="Kategori">Zorunlu (görüntüleme)</td>
              <td data-label="Amaç ve İşlenen Veri">Sitede kullanılan yazı tiplerinin yüklenmesi. Talep sırasında IP adresiniz ve tarayıcı bilginiz sağlayıcıya iletilir.</td>
            </tr>
            <tr>
              <td data-label="Teknoloji">jsDelivr (içerik dağıtım ağı)</td>
              <td data-label="Kategori">Zorunlu (görüntüleme)</td>
              <td data-label="Amaç ve İşlenen Veri">Arayüz kütüphanelerinin sunulması. Talep sırasında IP adresiniz ve tarayıcı bilginiz sağlayıcıya iletilir.</td>
            </tr>
            <tr>
              <td data-label="Teknoloji">Sunucu kayıtları (log)</td>
              <td data-label="Kategori">Zorunlu</td>
              <td data-label="Amaç ve İşlenen Veri">Güvenliğin sağlanması ve hataların tespiti. IP adresi, istek zamanı, ziyaret edilen sayfa ve tarayıcı bilgisi.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Sitede analitik veya reklam çerezleri kullanılmaya başlanması hâlinde bu
        metin güncellenecek ve gerekli açık rıza mekanizması devreye alınacaktır.
      </p>

      <h2 id="ucuncu-taraf">5. Üçüncü Taraf Bağlantıları</h2>
      <p>
        Yukarıdaki tabloda belirtilen sağlayıcılara yapılan talepler,
        teknik olarak IP adresinizin ilgili sağlayıcıya iletilmesini
        gerektirir. Bu sağlayıcıların bir kısmı Türkiye dışında yerleşiktir;
        aktarımlar Kanun'un 9. maddesi çerçevesinde gerçekleştirilir.
      </p>
      <p>
        Sitemiz ayrıca sosyal medya hesaplarımıza bağlantı içerir. Bu
        bağlantılara tıklamanız hâlinde ilgili platformun kendi çerez ve
        gizlilik politikaları geçerli olacaktır.
      </p>

      <h2 id="yonetim">6. Çerezleri Yönetme</h2>
      <p>
        Sitemizde analitik ve reklam çerezi kullanılmadığından, çerez tercih
        paneli sunulmamaktadır. Zorunlu ve işlevsellik amaçlı teknolojileri ise
        tarayıcı ayarlarınız üzerinden yönetebilirsiniz.
      </p>
      <p>
        Çoğu tarayıcı; çerezleri görüntülemenize, silmenize, üçüncü taraf
        çerezlerini engellemenize veya çerez yerleştirilmeden önce sizi
        uyarmasına imkân tanır. Yaygın tarayıcıların ilgili yardım sayfaları:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/tr/kb/cerezleri-silme-web-sitelerinin-bilgilerini-kaldirma" target="_blank" rel="noopener">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/tr-tr/guide/safari/sfri11471/mac" target="_blank" rel="noopener">Safari</a></li>
        <li><a href="https://support.microsoft.com/tr-tr/microsoft-edge/microsoft-edge-de-tanımlama-bilgilerini-silme-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener">Microsoft Edge</a></li>
      </ul>
      <p>
        Zorunlu teknolojilerin engellenmesi hâlinde, sohbet asistanı başta olmak
        üzere Sitenin bazı bölümlerinin düzgün çalışmayabileceğini hatırlatırız.
      </p>

      <h2 id="sure">7. Saklama Süreleri</h2>
      <p>Çerezlerin cihazınızda saklanma süresi türüne göre değişir:</p>
      <ul>
        <li><strong>Oturum çerezleri:</strong> Tarayıcınızı kapattığınızda silinir.</li>
        <li><strong>Kalıcı çerezler:</strong> Amaçlarına bağlı olarak belirli bir süre boyunca cihazınızda kalır.</li>
      </ul>
      <p>
        Sunucu kayıtları, <a routerLink="/aydinlatma-metni">Aydınlatma
        Metni</a>'nin saklama süreleri bölümünde belirtilen süreler boyunca
        saklanır.
      </p>

      <h2 id="aktarim">8. Elde Edilen Verilerin Aktarımı</h2>
      <p>
        Çerezler ve benzeri teknolojiler yoluyla elde edilen kişisel veriler,
        Kanun'un 8. ve 9. maddelerine uygun olarak, yukarıda belirtilen
        sağlayıcılar ile hizmetin gerektirdiği ölçüde paylaşılabilir. Ayrıntılı
        bilgiye <a routerLink="/aydinlatma-metni">Aydınlatma Metni</a> ve
        <a routerLink="/acik-riza-metni">Açık Rıza Metni</a> üzerinden
        ulaşabilirsiniz.
      </p>

      <h2 id="haklariniz">9. Haklarınız</h2>
      <p>Kanun'un 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
      <app-kvkk-haklariniz></app-kvkk-haklariniz>

      <h2 id="iletisim">10. İletişim</h2>
      <p>Çerezlerle ilgili sorularınız için bizimle iletişime geçebilirsiniz:</p>
      <app-veri-sorumlusu></app-veri-sorumlusu>

      <app-legal-links></app-legal-links>
    </div>
  </div>
</section>
